import { memo } from "react";
import { Table } from "react-bootstrap";
import BasicModal from "../_widgets/Modal/BasicModal";

const MultiMobileModal = memo(
  ({ modalShow, setModalShow, handleNumberSelection, handleClose, data, createNewPatient }) => {
    return (
      <>
        <BasicModal
          show={modalShow}
          size="lg"
          setModalShow={setModalShow}
          handleClose={handleClose}
          heading={"Select Patient"}
          footer={true}
          button2Text="Create New"
          button2Click={createNewPatient}
        >
          <div className="patients_ui custom_table" style={{ minHeight: "auto" }}>
            <Table responsive hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Father/Spouse Name</th>
                  <th>Aadhaar Number</th>
                  <th>Mobile Number</th>
                  <th>File Number</th>
                </tr>
              </thead>

              <tbody>
                {data?.map((data, index) => {
                  return (
                    <tr key={index} onClick={() => handleNumberSelection(data)}>
                      <td>{data?.name || "-"}</td>
                      <td>{data?.relation || "-"}</td>
                      <td>{data.aadhar_no || "-"}</td>
                      <td>{data.mno || "-"}</td>
                      <td>{data.file_no || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </BasicModal>
      </>
    );
  },
);

export default MultiMobileModal;
